import React, { FunctionComponent } from 'react';
import { chevronRightSlimIcon } from '@justgiving/icons';
import SVG from '@justgiving/svg';
import parseCurrency from '../../utils/parseCurrency';
import styles from './DonationPrompts.scss';
import { useNotNullableContext } from '../../hooks';
import { PageMetaContext } from '../../context/PageMetaContext';
import { Experiments } from '../../constants/experiments';

type DonationPromptProps = {
  message?: string | null;
  amount?: number | null;
  currency?: string | null;
};

export const DonationPrompt: FunctionComponent<DonationPromptProps> = ({
  amount,
  message,
  currency,
}) => {
  const { currentUrl } = useNotNullableContext(PageMetaContext);
  const monetaryValue = parseCurrency(currency ?? 'GBP', amount ?? 0, {
    roundDown: true,
    wholeNumber: true,
  });

  const hasValidMessage = message?.trim() !== '';
  if (!hasValidMessage) {
    return null;
  }

  const experiments = [
    // B2C_041 - Donation Prompts Part 2
    // Remove experiment once test completes (if successful)
    Experiments.b2c_041_fundraising_page_donation_prompts_2,
  ];
  // B2C_041 - Donation Prompts Part 2
  // Remove experiment and successType from component once test completes (if successful)
  const linkUrl = `${currentUrl}/donate?amount=${amount}&currency=${currency}&experiments=${experiments.join(
    ',',
  )}&successType=DonatePromptButtonClick`;

  return (
    <a
      className={styles.row}
      href={linkUrl}
      data-qa="jg-pages-donationprompts__row"
    >
      <div className={`${styles.amount} jg-h2 jg-text--medium`}>
        {monetaryValue}
      </div>
      <div className={`${styles.message} jg-text--small`}>{message}</div>
      <div className={styles.goarrow}>
        <div>
          <SVG markup={chevronRightSlimIcon} />
        </div>
      </div>
    </a>
  );
};

export default DonationPrompt;
